import Navbar from "../components/common/Navbar";
import InfluencerHero from "../components/influencerMarketing/InfluencerHero";
import InfluencerStats from "../components/influencerMarketing/InfluencerStats";
import InfluencerServices from "../components/influencerMarketing/InfluencerServices";
import InfluencerProcess from "../components/influencerMarketing/InfluencerProcess";
import InfluencerCampaigns from "../components/influencerMarketing/InfluencerCampaigns";
import InfluencerTiers from "../components/influencerMarketing/InfluencerTiers";
import InfluencerFaq from "../components/influencerMarketing/InfluencerFaq";
import InfluencerCta from "../components/influencerMarketing/InfluencerCta";
// Shares the Events & Experiences theme (type, buttons, section spacing).
// Scroll position on arrival is handled by MainLayout.
import "../styles/eventsExperiences.css";
import "../styles/influencerMarketing.css";

const InfluencerMarketingPage = () => (
  <div className="ee im">
    <Navbar />
    <InfluencerHero />
    <InfluencerStats />
    <InfluencerServices />
    <InfluencerProcess />
    <InfluencerCampaigns />
    <InfluencerTiers />
    <InfluencerFaq />
    <InfluencerCta />
  </div>
);

export default InfluencerMarketingPage;
